class ProductDimensions extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    if (!this?.externalEls?.trigger?.exists) return

    this.handleClick = this.handleClick.bind(this)

    this.listeners.add(
      this.externalEls.trigger.element,
      'click',
      this.handleClick,
    )
  }

  handleClick () {
    this.scrollIntoView({ behavior: 'smooth' })
  }
}

if (!customElements.get('product-dimensions')) {
  customElements.define('product-dimensions', ProductDimensions)
}
